
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/series/[slug]",
      function () {
        return require("private-next-pages/series/[slug]/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/series/[slug]"])
      });
    }
  